// extracted by mini-css-extract-plugin
export default {"container":"ImageTitle_container__c0OAm","clickable":"ImageTitle_clickable__0zX7v","wrapText":"ImageTitle_wrapText__2p3kq"};